<template>
    <div class="ajax-form">
        <input type="hidden" name="category" value="1">
        <div class="row">
            <div class="col-12">
                <div class="page__head-title page__head-title--orange">
                    <div class="page__head-title__text page__head-title__text--orange">Garantie Camping Car</div>
                    <div class="page__head-title__notice">(* champs obligatoires)</div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form_ttl">Informations sur le Camping-car à assurer :</div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Camping car neuf</div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--checkbox">
                        <input v-model="garantieCampingCar.is_new" name="is_new" type="radio" value="Oui" checked/> Oui
                        <input v-model="garantieCampingCar.is_new" name="is_new" type="radio" value="Non" /> Non
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item relative">
                    <div class="form__item__label form__item__label" :class="{'form__item__label--required':!isNewCar}">Immatriculation</div>
                    <div class="form__item__input-wrapper" :class="{ 'input-addon':existingVehicleFound || isVehicleSearching }">
                        <input
                                type="text"
                                v-model="garantieCampingCar.immatriculation"
                                @input="searchByRegNumber"
                                class="input_n"
                                :class="{input_red_shadow: hasError('immatriculation')}">

                        <div class="form__item__input-wrapper--loader" v-if="isVehicleSearching">
                            <Preloader :wrapper-height="'20px'" :size="'20px'" />
                        </div>
                        <!-- <button type="button" @click="fillTheFieldsByImmatriculation" class="form_bt form_confirm_button form__item__submit__button--small-helper" v-if="existingVehicleFound && !isVehicleSearching">
                            Compléter
                        </button> -->
                    </div>
                    <div class="tooltip__wrap">
                        <div class="tooltip__wrap--icon"></div>

                        <div class="tooltip__wrap--text">
                            <div class="tooltip__wrap--text--notice">Veuillez saisir l'immatriculation du véhicule en lettres majuscules et séparés par un trait d'union. Exemple: AF-785-HT</div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Marque du porteur</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="garantieCampingCar.marque_porteur" class="input_n"
                               :disabled="searchVehicleFilled && !isNewCar"
                               :class="{input_red_shadow: hasError('marque_porteur')}">
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Modèle du porteur</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="garantieCampingCar.modele_porteur" class="input_n"
                               :disabled="searchVehicleFilled && !isNewCar"
                               :class="{input_red_shadow: hasError('modele_porteur')}">
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Marque cellule</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="garantieCampingCar.marque_cellule" class="input_n"
                               :disabled="searchVehicleFilled && !isNewCar"
                               :class="{input_red_shadow: hasError('marque_cellule')}">
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Modèle cellule</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="garantieCampingCar.modele_cellule" class="input_n"
                               :disabled="searchVehicleFilled && !isNewCar"
                               :class="{input_red_shadow: hasError('modele_cellule')}">
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Puissance fiscale</div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--date">
                        <input type="text" v-model="garantieCampingCar.puis_fisc" class="input_n"
                               :disabled="searchVehicleFilled && !isNewCar"
                               :class="{input_red_shadow: hasError('puis_fisc')}">
                    </div>
                </div>
            </div>
            <div class="col-12">
            <div class="form__item">
                <div class="form__item__label form__item__label--required">Date de 1&egrave;re mise en circulation</div>
                <div class="form__item__input-wrapper form__item__input-wrapper--date currency-datepicker">
                    <CustomDatepicker :date.sync="circulationDateInput" :disabled="searchVehicleFilled" :has-error="hasError('jour_mise_en_circulation')"/>
                </div>
            </div>
        </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Num&eacute;ro de s&eacute;rie</div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--date">
                        <input type="text" v-model="garantieCampingCar.num_serie" class="input_n"
                               :disabled="searchVehicleFilled && !isNewCar"
                               :class="{input_red_shadow: hasError('num_serie')}"/>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Poids Total Autorisé En Charge</div>
                    <div class="form__item__input-wrapper">
                        <select v-model="garantieCampingCar.ptc" class="select_n" id="ptc"
                                :class="{input_red_shadow: hasError('ptc')}"
                                :disabled="searchVehicleFilled && !isNewCar">
                            <option v-for="option in ptcOptions" :value="option.value">{{option.name}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Kilométrage</div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--date">
                        <input type="text" v-model="garantieCampingCar.km_reel" class="input_n"
                               :class="{input_red_shadow: hasError('km_reel')}">
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Date d'effet</div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--date currency-datepicker">
                        <CustomDatepicker :date.sync="effectiveDateInput" :has-error="hasError('effective_date')"/>
                    </div>
                </div>
            </div>
            <div class="col-12">
              <div class="form__item">
                <div class="form__item__label form__item__label--required">Financement</div>
                <div class="form__item__input-wrapper form__item__input-wrapper--checkbox">
                  <input v-model="garantieCampingCar.finance" name="finance" type="radio" value="1"/> Oui
                  <input v-model="garantieCampingCar.finance" name="finance" type="radio" value="0" checked/> Non
                </div>
              </div>
            </div>
            <template v-if="garantieCampingCar.finance == 1">
              <div class="col-12">
                <div class="form__item">
                  <div class="form__item__label form__item__label--required">Organisme de financement</div>
                  <div class="form__item__input-wrapper form__item__input-wrapper--date">
                    <input type="text" v-model="garantieCampingCar.finance_name" class="input_n"
                           :class="{input_red_shadow: hasError('finance_name')}">
                  </div>
                </div>
              </div>
            </template>
            <div class="col-12">
                <div class="form_ttl">Information sur la garantie :</div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Type de garantie</div>
                    <div class="form__item__input-wrapper">
                        <select v-model="garantieCampingCar.garantie" class="select_n"
                                :class="{input_red_shadow: hasError('garantie')}"
                        >
                            <option value="0" selected="selected">Choisissez une garantie</option>
                            <option value="1">Réseau</option>
                            <option value="2">Maxi Réseau</option>
                            <template v-if="!isMaxiPlusEnabledByCirculation"></template>
                            <template v-else>
                              <option value="3" v-if="!isNewCar || (isNewCar && isMaxiPlusEnabled)">Maxi Plus</option>
                            </template>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Durée</div>
                    <div class="form__item__input-wrapper">
                        <select v-model="garantieCampingCar.duree" class="select_n" id="durationSelect"
                                :class="{input_red_shadow: hasError('duree')}"
                        >
                            <option value="0" selected="selected">Choisir une durée...</option>
                            <option value="1" v-if="!isNewCar && !isMaxiPlus">6 Mois</option>
                            <option value="2">12 Mois</option>
                            <option value="3">24 Mois</option>
                            <option value="4">36 Mois</option>
                            <option value="5" v-if="this.isNewCar && !isMaxiPlus">48 Mois</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item camping-car-assistance-item">
                    <div class="form__item__label form__item__label--required">Assistance souhaitée</div>
                    <div class="form__item__input-wrapper form__item__input-wrapper--date input-addon">
                        <select v-model="garantieCampingCar.assistance" class="select_n w-100">
                            <option value="0" selected="selected">Pack Assistance</option>
                            <option value="1">Sans pack assistance</option>
                        </select>
                        <button @click="showAssistanceDetails()" class="form_bt form_confirm_button form__item__submit__button--small-helper">
                            Voir détails
                        </button>

                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form_ttl_first">Informations sur le propriétaire du Camping-Car:</div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label">Civilit&eacute;</div>
                    <div class="form__item__input-wrapper">
                        <select v-model="garantieCampingCar.civilite">
                            <option value="0" selected="selected">M</option>
                            <option value="1">Mlle</option>
                            <option value="2">Mme</option>
                            <option value="3">Société</option>
                            <option value="4">Mr et Mme</option>
                        </select>
                    </div>
                </div>
            </div>

            <template v-if="garantieCampingCar.civilite == 3">
                <div class="col-12">
                    <div class="form__item">
                        <div class="form__item__label form__item__label--required">Société</div>
                        <div class="form__item__input-wrapper">
                            <input type="text" v-model="garantieCampingCar.name_of_signatory" name="name_of_signatory"
                                   id="name_of_signatory" class="input_n" :class="{input_red_shadow: hasError('name_of_signatory')}"/>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                  <div class="form__item">
                    <div class="form__item__label form__item__label--required">Nom du signataire</div>
                    <div class="form__item__input-wrapper">
                      <input type="text" v-model="garantieCampingCar.nom" name="nom" id="nom" class="input_n"
                             :class="{input_red_shadow: hasError('nom')}"/>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form__item">
                    <div class="form__item__label form__item__label--required">Pr&eacute;nom du signataire</div>
                    <div class="form__item__input-wrapper">
                      <input type="text" v-model="garantieCampingCar.prenom" name="prenom" id="prenom"
                             class="input_n" :class="{input_red_shadow: hasError('prenom')}"/>
                    </div>
                  </div>
                </div>
            </template>
            <template v-else>
                <div class="col-12">
                  <div class="form__item">
                    <div class="form__item__label form__item__label--required">Nom</div>
                    <div class="form__item__input-wrapper">
                      <input type="text" v-model="garantieCampingCar.nom" name="nom" id="nom" class="input_n"
                             :class="{input_red_shadow: hasError('nom')}"/>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                    <div class="form__item">
                        <div class="form__item__label form__item__label--required">Pr&eacute;nom</div>
                        <div class="form__item__input-wrapper">
                            <input type="text" v-model="garantieCampingCar.prenom" name="prenom" id="prenom"
                                   class="input_n" :class="{input_red_shadow: hasError('prenom')}"/>
                        </div>
                    </div>
                </div>
            </template>


            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Adresse</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="garantieCampingCar.adresse" class="input_n"
                               :class="{input_red_shadow: hasError('adresse')}">
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Code postal</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="garantieCampingCar.cp" maxlength="5" class="input_n"
                               :class="{input_red_shadow: hasError('cp')}">
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label--required">Ville</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="garantieCampingCar.ville" class="input_n"
                               :class="{input_red_shadow: hasError('ville')}">
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label">Téléphone</div>
                    <div class="form__item__input-wrapper" :class="{ 'input-addon': existingCustomerFound || isClientSearching }">
<!--                        <input type="text" v-model="garantieCampingCar.tel" @input="searchClient" maxlength="10" class="input_n"-->
<!--                               :class="{input_red_shadow: hasError('tel')}">-->
                      <input type="text" v-model="garantieCampingCar.tel" maxlength="10" class="input_n"
                             :class="{input_red_shadow: hasError('tel')}">

                        <div class="form__item__input-wrapper--loader" v-if="isClientSearching">
                          <Preloader :wrapper-height="'20px'" :size="'20px'" />
                        </div>
                        <!-- <button type="button" @click="fillTheFields" class="form_bt form_confirm_button form__item__submit__button--small-helper" v-if="existingCustomerFound && !isClientSearching">
                          Compléter
                        </button> -->
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label">Fax</div>
                    <div class="form__item__input-wrapper">
                        <input type="text" v-model="garantieCampingCar.fax" maxlength="10" class="input_n"
                               :class="{input_red_shadow: hasError('fax')}">
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item">
                    <div class="form__item__label form__item__label">Email</div>
                    <div class="form__item__input-wrapper">
                        <input type="email" v-model="garantieCampingCar.email" class="input_n"
                               :class="{input_red_shadow: hasError('email')}">
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="form__item justify-content-center mt-3 mb-3">
                    <div class="form__item__submit">
                        <Preloader v-if="isSending"/>
                        <input v-else
                               type="submit"
                               name="Submit"
                               value="VOIR LE DEVIS"
                               class="form_bt btnSendAjax form_confirm_button form__item__submit__button btn btn-block"
                               @click="onSubmit">
                    </div>
                </div>
            </div>
        </div>
        <ValidationErrors :errorsList="errors"/>
    </div>
</template>

<script>
    import ValidationErrors from '@/components/Garantie/ValidationErrors';
    import garantieFieldsLists from '../../mixins/garantieFieldsLists';
    import Preloader from '@/components/Preloader'
    import {DEBOUNCE} from "@/mixins/helper";
    import {TheMask} from 'vue-the-mask'
    import CustomDatepicker from '@/components/CustomInputs/CustomDatepicker';

    const INITIAL_FIELDS_VALUES = Object.freeze({
        civilite: 0,
        nom: '',
        prenom: '',
        name_of_signatory: '',
        adresse: '',
        cp: '',
        ville: '',
        tel: '',
        fax: '',
        email: '',
        // jour_naissance: 1,
        // mois_naissance: 1,
        // annee_naissance: new Date().getFullYear(),
        situation_famille: 0,
        profession: 0,
        is_new: null,
        code_garage: '',
        garantie: 0,
        duree: 0,
        immatriculation: '',
        immatriculation_ancien_numero: '',
        marque_porteur: '',
        modele_porteur: '',
        marque_cellule: '',
        modele_cellule: '',
        jour_mise_en_circulation: '',
        mois_mise_en_circulation: '',
        annee_mise_en_circulation: '',
        num_serie: '',
        puis_fisc: '',
        jour_prise_effet: '',
        mois_prise_effet: '',
        annee_prise_effet: '',
        jour_vente: 1,
        mois_vente: 1,
        annee_vente: new Date().getFullYear(),
        jour_livraison: 1,
        mois_livraison: 1,
        annee_livraison: new Date().getFullYear(),
        km_reel: '',
        assistance: 1,
        finance: 0,
        finance_name: '',
        ptc: 0
    });

    const CAR_TYPE_VP = 1;
    const CAR_TYPE_VU = 2;
    const CAR_TYPE_4X4 = 3;

    const CIVILITY_M = 0;
    const CIVILITY_MLLE = 1;
    const CIVILITY_MME = 2;
    const CIVILITY_SOCIETY = 3;

    export default {
        name: 'GarantieCampingCars',
        components: {ValidationErrors, Preloader, TheMask, CustomDatepicker},
        mixins: [garantieFieldsLists],
        data() {
            return {
                garantieCampingCar: {...INITIAL_FIELDS_VALUES},
                errors: {},
                isSending: false,
                searchResult: null,
                isClientSearching: false,
                effectiveDateInput: '',
                circulationDateInput: '',
                birstdayDateInput: '',
                isVehicleSearching: false,
                searchVehicleResult: null,
                searchVehicleFilled: false,
                isMaxiPlusEnabled: true,
                isMaxiPlusEnabledByCirculation: true
            }
        },
        computed: {
            isEditCampingCar() {
                return this.$route.params.id ? true : false
            },
            existingCustomerFound() {
                return !!this.searchResult;
            },
            existingVehicleFound() {
                return !!this.searchVehicleResult;
            },
            isNewCar() {
                return this.garantieCampingCar.is_new === 'Oui';
            },
            isMaxiPlus() {
                return +this.garantieCampingCar.garantie === 3;
            },
            ptcOptions() {
                return [
                    {value: '0', name: 'Chosir un PTC...'},
                    {value: '1', name: 'Inférieur ou égal à 3,5 T'},
                    {value: '2', name: 'Supérieur à 3,5 T mais inférieur ou égal à 5 T'},
                    {value: '3', name: 'Supérieur à 5 T'},
                ];
            },
        },
        watch: {
            'garantieCampingCar.is_new': function () {
                let optionsList = this.getListOfDurationOprions();
                if (!optionsList.includes(this.garantieCampingCar.duree)) this.garantieCampingCar.duree = '0';
                this.isMaxiPlusGarantieEnabled();
            },
            'garantieCampingCar.garantie': function () {
                if (!this.isNewCar) {
                    let optionsList = this.getListOfDurationOprions();
                    if (!optionsList.includes(this.garantieCampingCar.duree)) this.garantieCampingCar.duree = '0';
                }
            },
            'garantieCampingCar.km_reel': function (val) {
                if (!this.isNewCar) {
                  this.isMaxiPlusEnabled = (+val <= 120000);
                }
                else {
                  this.isMaxiPlusEnabled = (+val <= 40000);
                }
            },
            'circulationDateInput': function (val) {
              this.isMaxiPlusGarantieEnabled();
            }
        },
        methods: {
            searchByRegNumber: DEBOUNCE(function(val) {
                this.garantieCampingCar.immatriculation = this.garantieCampingCar.immatriculation.toUpperCase();

                let matched = this.garantieCampingCar.immatriculation.match(/(^([0-9]{2,}-[A-Z]{2,}-[0-9]{2,})+$)|(^([A-Z]{2,}-[0-9]{2,}-[A-Z]{2,})+$)|(^([0-9]{3}-[A-Z]{3}-[0-9]{2})+$)/g);

                if (matched) {
                    let url = 'client/registration',
                        data = {
                            regNumber: this.garantieCampingCar.immatriculation,
                            ccar: true
                        };
                    this.isVehicleSearching = true;
                    this.apiPost(url, data, false)
                        .then(response => {
                            if (response.data.info) {
                                this.searchVehicleResult = response.data.info;
                                this.parseVehicleInfo(this.searchVehicleResult);
                                this.searchVehicleFilled = true;
                            }

                            this.isVehicleSearching = false;
                        })
                        .catch(error => {
                            this.showErrorNotification(error);
                            this.isVehicleSearching = false;
                        })
                }
            }, 1000),
            fillTheFieldsByImmatriculation() {
                if (this.searchVehicleResult) {
                    this.parseVehicleInfo(this.searchVehicleResult);
                    this.searchVehicleFilled = true;
                    // this.searchVehicleResult = null;
                }
            },
            parseVehicleInfo(info) {
                // console.log('parseVehicleInfo | info', info);
                /* Car brand */
                if (info.Marque) {
                    this.garantieCampingCar.marque_porteur = info.Marque.toLocaleString();
                    this.garantieCampingCar.marque_cellule = info.Marque.toLocaleString();
                }

                /* Modele */
                this.garantieCampingCar.modele_porteur = info.Modele ? info.Modele.toLocaleString() : null;
                this.garantieCampingCar.modele_cellule = info.Modele ? info.Modele.toLocaleString() : null;
                /* Num serie */
                this.garantieCampingCar.num_serie = info.VIN ? info.VIN : null;

                if (info.PuissFisc) {
                    this.garantieCampingCar.puis_fisc = +info.PuissFisc;
                }

                if (info.DateMec) {
                    this.circulationDateInput = new Date(info.DateMec);
                    let date = this.moment(this.circulationDateInput).format('YYYY-MM-DD');
                    let minimumDate = (!this.isNewCar) ? this.moment().subtract(10, 'years').format('YYYY-MM-DD') : this.moment().subtract(24, 'months').format('YYYY-MM-DD');
                    let circulationBase = new Date(date).getTime();
                    let circulationMinimum = new Date(minimumDate).getTime();
                    //more than 2 years for NEW, more than 8 years for OLD
                    if (circulationMinimum > circulationBase) {
                      if (this.isNewCar) {
                        this.isMaxiPlusEnabledByCirculation = false;
                      }
                      else {
                        this.isMaxiPlusEnabledByCirculation = true;
                      }
                    }
                    else {
                      this.isMaxiPlusEnabledByCirculation = true;
                    }
                }
                if (info.PTR) {
                    if (+info.PTR <= 3500) {
                        this.garantieCampingCar.ptc = 1;
                    }
                    else if ((+info.PTR >= 3501) && (+info.PTR <= 5000)) {
                        this.garantieCampingCar.ptc = 2;
                    }
                    else if (+info.PTR >= 5001) {
                        this.garantieCampingCar.ptc = 3;
                    }
                }
            },
            searchClient: DEBOUNCE(function(val) {

                    if (this.garantieCampingCar.tel.length > 2) {
                        let url = 'client/searchOne',
                            data = {
                                tel: this.garantieCampingCar.tel
                            };
                        this.isClientSearching = true;
                        this.apiGet(url, data, false)
                            .then(response => {
                                if (response.data.client) {
                                    this.searchResult = response.data.client;
                                    this.parseClientInfo(this.searchResult);
                                    this.searchResult = null;
                                }

                                this.isClientSearching = false;
                            })
                            .catch(error => {
                                this.showErrorNotification(error);
                                this.isClientSearching = false;
                            })
                    }
            }, 1000),
            fillTheFields() {
                if (this.searchResult) {
                    this.parseClientInfo(this.searchResult);
                    this.searchResult = null;
                }
            },
            serializeData() {
                return this.garantieCampingCar;
            },
            onSubmit(event) {
                this.garantieCampingCar.immatriculation = (this.garantieCampingCar.immatriculation) ? this.garantieCampingCar.immatriculation.toUpperCase() : "";
                this.validateEffectiveDate();
                this.validateCirculationDate();
                // this.validateBirstdayDate();
                this.isSending = true;
                let url = 'garantie/camping_cars',
                    data = this.serializeData();
                if(this.isEditCampingCar) {
                    url = 'garantie/camping_cars/' + this.$route.params.id + '/edit';
                }
                this.apiPostFormData(url, data).then((response) => {
                    this.isSending = false;
                    this.errors = {};
                    if (response.data.calcQuotes)
                        this.$store.dispatch('updateCalcGaranties', response.data.calcQuotes);
                    this.showSuccessNotification(response.data.message, '');
                    let id = response.data.quote.id;
                    this.$router.push('/garantie-camping-cars-view/' + id);
                }).catch(error => {
                    this.isSending = false;
                    this.errors = error.response.data;

                    if(error.response.data.exception === 'App\\Exceptions\\PriceErrorException') {
                        this.errors.errors = {};
                        this.errors.errors.error = [error.response.data.message];
                    }
                })
            },
            getGuarantyInfo() {
                let url = 'garantie/' + this.$route.params.id;
                this.apiGet(url).then(response => {
                    this.garantieCampingCar = this.parseQuoteData(response.data.quote)
                }).catch(error => {
                    console.log(error)
                })
            },
            parseClientInfo(client) {
                this.garantieCampingCar.civilite = client.civility;
                this.garantieCampingCar.nom = client.last_name;
                this.garantieCampingCar.prenom = client.first_name;
                this.garantieCampingCar.name_of_signatory = client.name_of_signatory;
                this.garantieCampingCar.adresse = client.address;
                this.garantieCampingCar.cp = client.zip;
                this.garantieCampingCar.ville = client.city;
                this.garantieCampingCar.tel = client.tel;
                this.garantieCampingCar.email = client.email;
                this.garantieCampingCar.fax = client.fax;
                this.garantieCampingCar.id_client = client.id;
            },
            parseQuoteData(quote) {
                let parsedQuote = {};

                parsedQuote.finance = quote.finance || 0;
                parsedQuote.finance_name = quote.finance_name || '';

                if (quote.client && quote.client.id) {
                    parsedQuote.civilite = quote.client.civility;
                    parsedQuote.nom = quote.client.last_name;
                    parsedQuote.prenom = quote.client.first_name;
                    parsedQuote.adresse = quote.client.address;
                    parsedQuote.cp = quote.client.zip;
                    parsedQuote.ville = quote.client.city;
                    parsedQuote.tel = quote.client.tel;
                    parsedQuote.email = quote.client.email;
                    parsedQuote.id_client = quote.client.id;
                    parsedQuote.fax = quote.client.fax;
                    parsedQuote.situation_famille = quote.client.family;
                    parsedQuote.profession = quote.client.profession;

                    // if(quote.client.datesParse) {
                    //     parsedQuote.jour_naissance = quote.client.datesParse.day_birth;
                    //     parsedQuote.mois_naissance = quote.client.datesParse.month_birth;
                    //     parsedQuote.annee_naissance = quote.client.datesParse.year_birth;
                    //
                    //     this.birstdayDateInput = this.$root.normalizeDate(quote.client.datesParse.day_birth) + this.$root.normalizeDate(quote.client.datesParse.month_birth) + quote.client.datesParse.year_birth;
                    // }
                }

                if (quote.details) {
                    parsedQuote.is_new = quote.details.is_new;
                    parsedQuote.ptc = quote.details.ptc;
                    parsedQuote.code_garage = quote.details.code_garage;
                    parsedQuote.garantie = quote.details.garantie;
                    parsedQuote.duree = quote.details.duration;
                    parsedQuote.immatriculation = quote.details.registration;
                    parsedQuote.immatriculation_ancien_numero = quote.details.registration_old_number;
                    parsedQuote.marque_porteur = quote.details.marque_porteur;
                    parsedQuote.modele_porteur = quote.details.modele_porteur;
                    parsedQuote.marque_cellule = quote.details.marque_cellule;
                    parsedQuote.modele_cellule = quote.details.modele_cellule;

                    parsedQuote.jour_mise_en_circulation = quote.details.day_circulation;
                    parsedQuote.mois_mise_en_circulation = quote.details.month_circulation;
                    parsedQuote.annee_mise_en_circulation = quote.details.year_circulation;

                    this.circulationDateInput = new Date(
                        quote.details.year_circulation,
                        quote.details.month_circulation - 1,
                        quote.details.day_circulation,
                    );

                    parsedQuote.num_serie = quote.details.serial_number;
                    parsedQuote.puis_fisc = quote.details.fiscal_power;

                    if(quote.details.datesParse) {
                        let effective_day = quote.details.datesParse.day_effective,
                            effective_month = quote.details.datesParse.month_effective -1 ,
                            effective_year = quote.details.datesParse.year_effective;
                        parsedQuote.jour_prise_effet = effective_day;
                        parsedQuote.mois_prise_effet = effective_month;
                        parsedQuote.annee_prise_effet = effective_year;

                        this.effectiveDateInput = new Date(effective_year, effective_month, effective_day);

                        parsedQuote.jour_vente = quote.details.datesParse.day_sale;
                        parsedQuote.mois_vente = quote.details.datesParse.month_sale;
                        parsedQuote.annee_vente = quote.details.datesParse.year_sale;

                        parsedQuote.jour_livraison = quote.details.datesParse.day_delivery;
                        parsedQuote.mois_livraison = quote.details.datesParse.month_delivery;
                        parsedQuote.annee_livraison = quote.details.datesParse.year_delivery;
                    }


                    parsedQuote.km_reel = quote.details.km_real;
                    parsedQuote.assistance = quote.details.assistance;
                }

                this.searchVehicleFilled = true;

                return parsedQuote;
            },
            validateEffectiveDate() {
                if(!this.effectiveDateInput) return false;
                let date = this.moment(this.effectiveDateInput);

                this.garantieCampingCar.jour_prise_effet = date.format('D');
                this.garantieCampingCar.mois_prise_effet = date.format('M');
                this.garantieCampingCar.annee_prise_effet = date.format('YYYY');

                return true;
            },
            resetEffectiveDate() {
                this.garantieCampingCar.jour_prise_effet = 1;
                this.garantieCampingCar.mois_prise_effet = 1;
                this.garantieCampingCar.annee_prise_effet = 1970;
            },
            cleanEffectiveDate() {
                this.garantieCampingCar.jour_prise_effet = '';
                this.garantieCampingCar.mois_prise_effet = '';
                this.garantieCampingCar.annee_prise_effet = '';
            },
            validateCirculationDate() {
                if(!this.circulationDateInput) return false;
                let date = this.moment(this.circulationDateInput);

                this.garantieCampingCar.jour_mise_en_circulation = date.format('D');
                this.garantieCampingCar.mois_mise_en_circulation = date.format('M');
                this.garantieCampingCar.annee_mise_en_circulation = date.format('YYYY');

                return true;
            },
            resetCirculationDate() {
                this.garantieCampingCar.jour_mise_en_circulation = '';
                this.garantieCampingCar.mois_mise_en_circulation = '';
                this.garantieCampingCar.annee_mise_en_circulation = '';
            },
            getListOfDurationOprions() {
                let list = [],
                    options = document.getElementById("durationSelect").options;

                for (let option of options ) {
                    list.push(+option.value);
                }

                return list;

            },
            showAssistanceDetails() {
                let win = window.open('https://assur-camping-car.fr/particulier/produits-assistance-particuliers/pack-assistance-particuliers/', '_blank');
                win.focus();
            },
            hasError(field) {
                return !!(this.errors.errors && this.errors.errors[field]);
            },
            isMaxiPlusGarantieEnabled() {
              let date = this.moment(this.circulationDateInput).format('YYYY-MM-DD');
              let minimumDate = (!this.isNewCar) ? this.moment().subtract(10, 'years').format('YYYY-MM-DD') : this.moment().subtract(24, 'months').format('YYYY-MM-DD');
              // console.log(`circulationDateInput| this.isNewCar => ${this.isNewCar} | minimumDate => ${minimumDate} | fromDateInput => ${date}`);
              let circulationDateFromInput = new Date(date).getTime();
              let circulationMinimum = new Date(minimumDate).getTime();
              //more than 2 years for NEW, more than 8 years for OLD
              if (circulationMinimum > circulationDateFromInput) {
                this.isMaxiPlusEnabledByCirculation = false;
              }
              else {
                this.isMaxiPlusEnabledByCirculation = true;
              }
              // console.log(`this.isMaxiPlusEnabledByCirculation [checker] => ${this.isMaxiPlusEnabledByCirculation}, this.isNewCar => ${this.isNewCar}`);
            }
        },
        beforeRouteLeave(to, from, next) {
            this.garantieCampingCar = INITIAL_FIELDS_VALUES;
            next();
        },
        mounted() {
            if (this.$route.params.id) {
                this.getGuarantyInfo();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/GarantieCampingCars.vue